var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"map-data"}},[_c('div',{staticClass:"map-data-title"},[_vm._v("\n    "+_vm._s(_vm.$t("deviceMap"))+"\n  ")]),_vm._v(" "),_c('div',{attrs:{"id":"map-data-content"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dab7e0a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MapData.vue
// module id = null
// module chunks = 